import { z } from 'zod';

export const pipelineParamsSchema = z.object({
  pipelineId: z.coerce.number(),
});

export const pipelineSearchSchema = z.object({
  asset: z.string().optional().default(''),
  mediaId: z.string().optional().default(''),
});
